import { useTranslation } from 'react-i18next';

interface MyButtonProperties {
  label: string;
  buttonType:
    | 'submit'
    | 'back'
    | 'error'
    | 'outline'
    | 'active-outline'
    | 'warning'
    | 'none'
    | 'primary-outline'
    | 'primary-outline-none'
    | 'gray'
    | 'hover'
    | 'danger-outline'
    | 'primary';
  disableHoverEffect?: boolean;
  svgIcon?: JSX.Element;
  svgBackIcon?: JSX.Element;
  onClickFunc?: () => void;
  valueRequired?: boolean;
  notifyCount?: number | null;
  loading?: boolean;
  disableButton?: boolean;
  disableClass?: string;
  hoverLabel?: string;
  labelColorFill?: string;
  svgColorFill?: string;
}

/**
 * Shared button component
 * @param {any} param0 - The param0
 * @param {any} param0.label - The label prop
 * @param {any} param0.buttonType - The buttonType prop
 * @param {any} param0.svgIcon - The svgIcon prop
 * @param {any} param0.svgBackIcon - The svgBackIcon prop
 * @param {any} param0.disableHoverEffect - The disableHoverEffect prop
 * @param {any} param0.onClickFunc - The onClickFunc prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.notifyCount - The notifyCount prop
 * @param {any} param0.loading - The loading prop
 * @param {any} param0.disableClass - The disableClass prop
 * @param {any} param0.disableButton - The disableButton prop
 * @param {any} param0.hoverLabel - The hoverLabel prop
 * @param {any} param0.labelColorFill - The labelColorFill prop
 * @param {any} param0.svgColorFill - The svgColorFill prop
 * @returns  The rendered button component.
 */
function MyButton({
  label,
  buttonType,
  svgIcon,
  svgBackIcon,
  disableHoverEffect,
  onClickFunc,
  valueRequired,
  notifyCount,
  loading,
  disableClass,
  disableButton,
  hoverLabel,
  labelColorFill,
  svgColorFill,
}: Readonly<MyButtonProperties>) {
  const { i18n } = useTranslation();

  return (
    <div className="button-wrap" dir={i18n.dir()}>
      <button
        type="button"
        className={`${buttonType}-button ${disableHoverEffect ? '' : 'on-hover'} ${buttonType} ${disableClass}`}
        disabled={disableButton}
        onClick={onClickFunc}
        style={
          {
            '--label-color': labelColorFill || undefined,
            '--svg-color': svgColorFill || undefined,
          } as React.CSSProperties
        }>
        {svgIcon && (
          <span className="button-icon-start">{svgIcon}</span>
        )}
        {label && (
          <span className="button-label">
            {label}
          </span>
        )}
        {svgBackIcon && <span className="button-icon-end">{svgBackIcon}</span>}
        {notifyCount && notifyCount > 0 ? (
          <span className="button-notifyCount">{notifyCount}</span>
        ) : (
          ''
        )}
        {valueRequired && <span className="value-required-indicator">*</span>}
      </button>
      {hoverLabel && <div className="hover-label">{hoverLabel}</div>}
      {loading && (
        <div className="button-loader-wrap">
          <div className="button-loader-container">
            <div className="button-loader" />
          </div>
        </div>
      )}
    </div>
  );
}

MyButton.defaultProps = {
  onClickFunc: null,
  disableHoverEffect: false,
  valueRequired: false,
  svgIcon: null,
  svgBackIcon: null,
  notifyCount: null,
  disableClass: null,
  loading: false,
  disableButton: false,
  hoverLabel: '',
  labelColorFill: '',
  svgColorFill: '',
};

export default MyButton;
